import { render } from "./VerificationPage.vue?vue&type=template&id=4c9fb7c8&scoped=true"
import script from "./VerificationPage.vue?vue&type=script&lang=js"
export * from "./VerificationPage.vue?vue&type=script&lang=js"

import "./VerificationPage.vue?vue&type=style&index=0&id=4c9fb7c8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c9fb7c8"]])

export default __exports__